import { Component } from 'san';
import * as _ from 'lodash';
import axios from 'axios';
import { IShowEditProjectAttributeParams } from 'src/models';

export default class EditProjectAttribute extends Component {
    constructor(options: any) {
        super(options);
    }

    static computed = {
        title: function () {
            const typeDescription = this.data.get('attributeTypeDescription');
            return this.data.get('isNew') ? `新增${typeDescription}` : `编辑${typeDescription}`;
        },
        valid: function () {
            const data = this.data.get('data');
            return data && data.name && data.code;
        },
    };

    initData() {
        return {
            isShow: false,
            isNew: false,
            attributeType: 10,
            attributeTypeDescription: '',
            data: this.getDefaultData(),
            callback: null,
        };
    }

    getDefaultData() {
        return _.cloneDeep({
            code: '',
            name: '',
            rank: 0,
            remark: '',
            is_disabled: false,
        });
    }

    show(params: IShowEditProjectAttributeParams) {
        this.data.set('isShow', true);
        this.data.set('isNew', params?.isNew);
        this.data.set('attributeType', params?.attributeType);
        this.data.set('attributeTypeDescription', params?.attributeTypeDescription);
        this.data.set('callback', params?.callback);
        if (params.isNew) {
            this.data.set('data', this.getDefaultData());
        } else {
            this.data.set('data', params.projectAttribute);
        }
    }

    submit() {
        const data = this.data.get('data');
        const attributeType = this.data.get('attributeType');
        const callback = this.data.get('callback');
        if (this.data.get('isNew')) {
            this.createAttribute(Object.assign(data, { type: attributeType })).then(() => {
                this.cancel();
                if (callback) {
                    callback();
                }
            });
        } else {
            this.updateAttribute(data).then(() => {
                this.cancel();
                if (callback) {
                    callback();
                }
            });
        }
    }

    cancel() {
        this.data.set('isShow', false);
        this.data.set('isNew', false);
        this.data.set('data', this.getDefaultData());
        this.data.set('attributeType', 10);
        this.data.set('attributeTypeDescription', '');
    }

    createAttribute(data) {
        return axios.post('/api/projects/project-attributes', data);
    }

    updateAttribute(data) {
        return axios.put('/api/projects/project-attributes/' + data.id, data);
    }
}
